import React from 'react';

import type { ExtensionHandlerProps } from '@confluence/fabric-extension-lib/entry-points/commonExtensionTypes.ts';
import { PageIncludeMacroHandler } from '@confluence/page-include-macro/entry-points/PageIncludeMacroRenderer.ts';
import type { PageIncludeMacroParams } from '@confluence/page-include-macro/entry-points/PageIncludeMacroTypes.ts';

import { NestedAdfRendererWrapperProvider } from '../NestedAdfRendererWrapper.tsx';

type PageIncludeExtensionHandlerProps = ExtensionHandlerProps & {
	Renderer: React.FC<any>;
	appearance?: string;
	macroParams?: PageIncludeMacroParams;
};

export const PageIncludeExtensionHandler = ({
	Renderer,
	appearance,
	macroParams,
	...macroDefaultProps
}: PageIncludeExtensionHandlerProps): React.JSX.Element => (
	<NestedAdfRendererWrapperProvider Renderer={Renderer} appearance={appearance}>
		{(RendererWrapper) => (
			<PageIncludeMacroHandler
				macroDefaultProps={macroDefaultProps}
				macroParams={macroParams}
				RendererWrapper={RendererWrapper}
			/>
		)}
	</NestedAdfRendererWrapperProvider>
);
